import { Component } from 'react';
import { connect } from 'react-redux';

import {
  listReservationAvailabilities,
  resetReservationAvailability
} from 'redux/reservationAvailabilities/actions';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';

import { createSearchString } from './helpers';
import AvailabilityListWidget from './list/AvailabilityListWidget';
import SearchFormWidget from './search/SearchFormWidget';

class AvailabilityForReservationType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      reservationTypeId: null,
      reservationDate: null,
      guestCount: null,
      reservationTime: null
    };
  }

  handleSearch = (data) => {
    const { props } = this;
    const params = data;
    const { reservationType } = props;
    this.setState({
      isSearch: true,
      reservationTypeId: reservationType.id,
      reservationDate: params.reservationDate,
      reservationTime: params.reservationTime,
      guestCount: params.guestCount
    });
    params.reservationTypeId = reservationType.id;
    const searchString = createSearchString(params, props.settings);
    props.resetReservationAvailability();
    props.listReservationAvailabilities(searchString, 'Availability');
  };

  render() {
    const { settings, form, reservationType, reservationTypeSlug } = this.props;
    const { isSearch, reservationTypeId } = this.state;
    const { reservationDate, reservationTime, guestCount } = this.state;
    if (!settings.data) {
      return null;
    }
    if (!reservationType) {
      return null;
    }
    return (
      <>
        <SearchFormWidget
          form={form}
          onSearch={this.handleSearch}
          reservationDate={reservationDate}
          reservationTypeSlug={reservationTypeSlug}
        />
        {isSearch && (
          <AvailabilityListWidget
            onSearch={this.handleSearch}
            reservationDate={reservationDate}
            guestCount={guestCount}
            reservationTime={reservationTime}
            reservationTypeId={reservationTypeId}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  settings: state.setting,
  reservationType: getReservationTypeBySlug(
    state.reservationType,
    ownProps.reservationTypeSlug
  )
});

export default connect(mapStateToProps, {
  listReservationAvailabilities,
  resetReservationAvailability
})(AvailabilityForReservationType);
